import { Button } from "../../../components/forms";
import { GoPlus } from "react-icons/go";
import { ListPicker } from "../../../components/generic/ListPicker";
import { usePickerhook } from "../../../hooks/usePickerhook";
import { SearchBar } from "../../../components/generic/SearchBar";
import { useState } from "react";
import { useDeptHook } from "../../../hooks/useDeptHook";
import { NoEmployee } from "../../../components/users/NoEmployee";
import AddEmployee from "../../../components/Modules/Employees/AddEmployee";
import EmployeeItem from "./EmployeeItem";
import useDepartmentHook from "../../../hooks/useDepartmentHook";
import useEmployeeHook from "../../../hooks/useEmployeeHook";
import AddPosition from "../../../components/Modules/Employees/AddPositionModal";
import usePositionHook from "../../../hooks/usePositionHook";
import AddPositionModal from "../../../components/Modules/Employees/AddPositionModal";
import PositionItem from "./PositionItem";

export default () => {
  const departmentPicked = usePickerhook();
  const positionPicked = usePickerhook();
  const [showadddept, setshowadddept] = useState(false);
  const { selectedOrgEmployees } = useEmployeeHook();
  const { selectedOrgDepts } = useDepartmentHook();
  const [entered, setentered] = useState("");
  const { AddPosition, refresh, allorgPositions } = usePositionHook();
  const onChange = (e: string) => {
    setentered(e);
  };

  return (
    <div className="w-full pr-20  flex  ">
      {showadddept && (
        <AddPositionModal
          AddPosition={AddPosition}
          allorgPositions={allorgPositions}
          refresh={refresh}
          show={setshowadddept}
        />
      )}
      <div className={` p-6 bg-white    w-full  rounded-[20px]`}>
        <div className="  w-full  flex justify-between items-center  ">
          <p className="text-textbg font-medium text-sm mb-2 text-[16px] bg-white">
            Positions({allorgPositions.length})
          </p>

          <Button
            width={200}
            disabled={false}
            text={
              <>
                {" "}
                <GoPlus size={15} className=" mx-1 inline" /> Add Position
              </>
            }
            onBtnClick={() => {
              setshowadddept(true);
            }}
          />
        </div>

        <hr />

        {
          <div className="py-4 flex flex-col gap-4 px-10">
            {allorgPositions.map((i: any) => (
              <PositionItem item={i} />
            ))}
          </div>
        }
      </div>
    </div>
  );
};
